import React, { Component } from "react";


import Card from "@material-ui/core/Card";

import { TextField,IconButton } from "@material-ui/core";

import Snackbar from "@material-ui/core/Snackbar"

import CloseIcon from '@material-ui/icons/Close'

// import '../App.css';

import '../../App.css'

import { Button } from "@material-ui/core";


import {forgotPassword} from '../../services/userServices'


export default class ForgotPassword extends Component {





  constructor() {
    super();

    this.state = {
      fields: {
        email: ""
      },
      errors: {},
      snackbarMessage: '',
      openSnackBar: false,
      status: false
    }
  }

  handleChange = e => {
    try {
      let fields = this.state.fields;
      fields[e.target.name] = e.target.value;
      this.setState({ fields });
      this.setState({ [e.target.name]: e.target.value });
    } catch (err) {
      console.log('error in handlechange');
    }
  }


  handleSubmit = e => {
    e.preventDefault();
    if (this.validateForm()) {
      let fields = {};
      fields['email'] = this.state.fields.email;
      this.setState({ fields: fields });

      var data = {
        email: this.state.fields.email
      };

      this.setState({
        openSnackBar: true,
        snackbarMessage: "Successfull"
      })


      forgotPassword(data)
        .then(response => {
          setTimeout(() => {
            this.Redirect();
          }, 500)
        })
        .catch(err => {
          console.log(err);
          this.setState({
            openSnackBar: true,
            snackbarMessage: "Failure"
          })
        })
    }
  }

  Redirect = () => {
    this.props.history.push('/login')
  }



  handleSnackClose = () => {
    try {
      this.setState({
        openSnackBar: false
      })
    } catch (err) {
      console.log('error at handleSnackclose');

    }
  };



  registerclick = e => {
    try {
      e.preventDefault();
      this.props.history.push("/register");
    } catch (err) {
      console.log("error at registrationclick in forgotPassword");
    }
  };


  loginClick = e => {
    try {
      e.preventDefault();
      this.props.history.push('/login');
    } catch (err) {
      console.log('Error at loginclick in forgotPassword')
    }
  }

  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "*Please enter your email-ID.";
    }

    this.setState({
      errors: errors
    });
    return formIsValid
  }

  render() {
    return (
      <div>
        <Card className='Card'>
          <div className="content" >

            <div id="TitleBar"> ChromaFan </div>

            <div id="info1"> Forgot your Password? </div>

            <div id="info2"> You can reset your password here. </div>

            <form onSubmit={this.handleSubmit} >
              {/* <TextField
                type="email"
                label="Email-Id"
                id="email"
                margin="normal"
                variant="outlined"
                value={this.state.fields.email}
                onChange={this.handleChange}
              // style={{ width: '75%' }}
              />
              <div className="errorMsg">{this.state.errors.email}</div> */}




              <div className="emailField">
                <TextField
                  type="email"
                  label="Email-Id"
                  // id="email"
                  name="email"
                  // className="outlined-email"
                  margin="normal"
                  variant="outlined"
                  value={this.state.fields.email}
                  onChange={this.handleChange}
                  className='TextfieldEmailFoG'
                
                />
                <div className="errorMsgF">{this.state.errors.email}</div>
              </div>



              <div style={{ textAlign: 'center', }}>
                <Button type="submit"
                  // style={{ width: '50%', }}
                  id='button12'
                  title="Reset-Password"> Reset Password</Button>
              </div>








              {/* <div style={{ margin: '2%' }}>
                <Button variant="contained"
                 color="primary"
                  >
                  Reset Password
                 </Button>
              </div> */}

              <div className="BottomBar">
                <div>
                  <Button color="primary"
                    id="LinkButton"
                    title="Back to Login"
                    onClick={this.loginClick}   >
                    Back To Login
                </Button>
                </div>


                <div>
                  <Button
                    color="primary"
                    id="LinkButton"
                    title="Click to register"
                    onClick={this.registerclick}
                  >
                    Create Account
                  </Button>
                </div>
              </div>


            </form>



          </div>
        </Card>



         <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "left"
          }}
          open={this.state.openSnackBar}
          autoHideDuration={6000}
          onClose={this.handleSnackClose}
          variant="error"
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={<span id="message-id"> {this.state.snackBarMessage} </span>}
          action={[
            <div>
              <IconButton
                key="close"
                aria-label="Close"
                onClick={this.handleSnackClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          ]}
        /> 
















      </div>
    )
  }
}

  // {/* <div id="LoginButt">
  //                               <Button type='submit'
  //                                   title='Login' >Submit</Button>
  //                           </div> */}